import { t as uiText } from '../../i18n';
import React from 'react';
import './Day0Panel.css';
import OGASetting from '../../components/OGASetting';
import type { ContactPathSeed } from './contactPathHints';

interface ContactPathPanelProps {
  workspaceId: string;
  seed: ContactPathSeed;
  onSaved: () => void | Promise<void>;
  onClose: () => void;
}

const ContactPathPanel: React.FC<ContactPathPanelProps> = ({
  workspaceId,
  seed,
  onSaved,
  onClose,
}) => {
  return (
    <section className="day0-panel">
      <header className="day0-panel__header">
        <h2 className="day0-panel__title">{uiText("Contact path")}</h2>
        <button type="button" className="day0-panel__close" onClick={onClose} aria-label={uiText("Close")}>
          ×
        </button>
      </header>
      <p className="day0-panel__lead">{uiText("Turn on only what you need. You can save with everything off.")}</p>
      <OGASetting
        workspaceId={workspaceId}
        variant="panel"
        seed={seed}
        onSaved={onSaved}
      />
    </section>
  );
};

export default ContactPathPanel;
